<!-- 尾部组件 -->
<script lang='ts' setup>
import { useRouter } from 'vue-router';
import { downData } from '../listData/downShow'
// 底部跳转函数
let router = useRouter()
const skip = (path: string | undefined, section: string | undefined, id: number | undefined) => {
    if (path != undefined) {
        router.push(path)
    }
    if (id == 4) {
        router.push({ path: '/partner.html', query: { '合作伙伴': section } })
    }
    if (id == 1) {
        router.push({ path: '/about.html', query: { 'about_nav': section } })
    }
}
// 底部跳转页面
const skipFn = (str: string) => {
    if (str == '控制柜') {
        router.push({ path: '/products.html' })
    }
    else if (str == '行业终端设备') {
        router.push({ path: '/terminal.html' })
    }
    else if (str == '智慧管控平台') {
        router.push({ path: '/wisdom.html' })
    }
}
</script>
<template>
    <div class="center-block">
        <div class="centerTop">
            <div class="information">
                <div class="informationLeft">
                    <div class="log"></div>
                    <div class="phone">
                        <p>欢迎添加宇启升官方微信或拨打热线</p>
                        <p>电话详询！</p>
                        <p>全国热线：<span style="font-size: 20px;">400-016-2918/<br />13809089616</span></p>
                    </div>
                </div>
                <div class="informationRight">
                    <div class="weChat">
                        <div class="img"></div>
                        <div class="sweep">微信扫一扫</div>
                    </div>
                </div>
            </div>
            <div class="serve">
                <h3 class="serveTitle">产品与服务</h3>
                <div class="butFn">
                    <el-button v-for="item in downData[2].urls" size="large" color="#f00" :dark="true" plain
                        @click="skipFn(item.partText)">{{
                            item.partText
                        }}</el-button>
                </div>
            </div>
            <div class="yqsFn">
                <ul class="uqsFn_foot">
                    <li v-for="(item, index) in downData">
                        <div class="uqsFn_foot_li" v-if="index != 2 && index != 0">
                            <h3 class="fnTitle">{{ item.title }}</h3>
                            <div class="sectio_fn" v-for="item1 in item.urls"
                                @click="skip(item1.path, item1.section, item1.id)">
                                {{ item1.partText }}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="centerFoot">
            <div class="centerFoor_left">
                <el-breadcrumb separator="|">
                    <el-breadcrumb-item :to="{ path: '/join_us.html' }">加入我们</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/enterprise_culture.html' }">企业文化</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/contact.html' }">联系我们</el-breadcrumb-item>
                    <el-breadcrumb-item></el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <p class="footer-v5-copright-text">
                江苏南通宇启升机电设备有限公司&nbsp;&nbsp;
                <span class="foot-ga" ></span>
                &nbsp;
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32060202002042" target="_blank">苏公网安备32060202002042号</a>
            </p>
        </div>
    </div>
</template>
<style  lang='less' scoped>


.fontStyle {
    font-size: 16px;
    color: #cccccc;
    text-align: center;
    margin-bottom: 0;
}

.flex {
    display: flex;
    justify-content: center;
    align-items: center;
}

.butFnMagin {
    margin: 20px 10px 10px 0;
}

.center-block {
    height: 400px;
    width: 100%;
    min-width: 1200px;
    background: url('../assets/image/index_bc2.png') no-repeat;
    background-size: cover;
    .centerFoot {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        min-width: 1200px;
        padding: 10px 30px;
        color: #A9A9A9;
        border-top: 1.5px rgba(255, 255, 255, 0.2) solid;

        /deep/ .el-breadcrumb__inner.is-link:hover {
            color: #f00;
        }

        /deep/ .el-breadcrumb__inner.is-link {
            color: #A9A9A9;
        }

        .footer-v5-copright-text {
            .foot-ga{
                display: inline-block;
                width: 14px;
                height: 16px;
                background: url('../assets/image/foot-ga.png') no-repeat;
                background-size: contain;
            }
            text-align: right;

            a {
                color: #4d98ce;
            }

            a:hover {
                text-decoration: underline;
            }
        }
    }

    .centerTop {
        padding: 30px 30px 10px 30px;
        display: flex;
        color: #A9A9A9;
        font-size: 14px;
        justify-content: space-around;

        .information {
            .informationLeft {
                .log {
                    background: url(../assets/image/logo1.png) no-repeat;
                    background-size: contain;
                    width: 300px;
                    height: 50px;
                    margin-left: -10px;
                }

                .phone {
                    p {
                        line-height: 24px;
                    }
                }
            }

            .informationRight {
                .img {
                    background: url('../assets/image/wechat.png') 50% 50% no-repeat;
                    background-size: cover;
                    width: 100px;
                    height: 100px;
                }

                .sweep {
                    margin: 2px 20px;
                }
            }
        }

        .serve {
            width: 390px;

            .butFn {
                .el-button {
                    width: 120px !important;
                    .butFnMagin()
                }

                .el-button+.el-button {
                    .butFnMagin()
                }
            }

            .serveTitle {
                padding-bottom: 20px;
                color: #fff;
                border-bottom: 1.5px rgba(255, 255, 255, 0.2) solid;
            }
        }

        .yqsFn {
            .uqsFn_foot {
                display: flex;

                .uqsFn_foot_li {
                    margin: 0 20px;

                    .fnTitle {
                        padding-bottom: 20px;
                        color: #fff;
                        border-bottom: 1.5px rgba(255, 255, 255, 0.2) solid;
                    }

                    .sectio_fn {
                        margin: 20px 0;
                    }

                    .sectio_fn:hover {
                        color: #f00;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 768px) {
    .center-block {
        height: 520px ;
        min-width: 0 ;
        background-size: cover ;

        .centerTop {
            display: block ;
            .information{
                text-align: center;
                .informationRight{
                    .img{
                        text-align: center;
                        margin: 0 auto;
                    }
                }
            }
            .yqsFn {
                display: none ;
            }

            .serve {
                width: auto;
                .butFn {
                    text-align: center;
                    .el-button {
                        width: 80px !important;
                        font-size: 12px ;
                    }
                }
            }
        }

        .centerFoot {
            display: block ;
            min-width: 0 ;
            .footer-v5-copright-text{
                text-align: left;
                margin: 10px 0;
                font-size: 14px;
                font-weight: 700;
            }
        }
    }
}
</style>